// restorePanel.js
var RestorePanel = pc.createScript('restorePanel');

RestorePanel.attributes.add('YesButton',{type: 'entity'});
RestorePanel.attributes.add('NoButton',{type: 'entity'});
RestorePanel.attributes.add("main", {type: "entity"});

RestorePanel.prototype.initialize = function() {
    
    this.main.enabled = false;
    
    this.YesButton.button.on('click', function(event) {
        
        this.entity.enabled = false;
        this.main.enabled = true;
       
        if (playExtraTime == true) {
            //ADSManager.instance.OpenRewardVideo(adsEnum.Interstitial);
        }
        else {
            GameManager.instance.GameStart();
        }
        
    },this);
    
    this.NoButton.button.on('click', function(event) {
        
        clearCacheFunction();
        roomObjectList = [];
        
        PlayerManager.instance.userData.roomAssets = [];
        PlayerManager.instance.userData.lastTimeProgressBar =  null;
        PlayerManager.instance.userData.savedMatchedObjectCount =  null;
        PlayerManager.instance.userData.interruption = 0;
        PlayerManager.instance.userData.score = 0;
        PlayerManager.instance.SavePlayerData();
        
        userLevel = GameData.instance.getLevelData(PlayerManager.instance.userData.level);
        //GameManager.instance.LoadData(userLevel, "level");
        PlayerManager.instance.loadLevelData(userLevel);
        

        this.entity.enabled = false;
        this.main.enabled = true;
        
        if (playExtraTime == true) {
            //ADSManager.instance.OpenRewardVideo(adsEnum.Interstitial);
        }
        else {
            GameManager.instance.GameStart();
        }
    },this);
};



